// Auto-generated TypeScript enum from PHP enum

export type FilterOperator = 'all' | 'between' | 'contains' | 'elem_match' | 'ends_with' | '=' | 'exists' | '>' | '>=' | 'has_value' | 'in' | 'is' | 'is_not' | 'is_not_null' | 'is_null' | '<' | '<=' | 'missing_value' | 'mod' | 'not' | '!=' | 'not_exists' | 'not_in' | 'regex' | 'search' | 'starts_with';

export const FilterOperator = {
  All: 'all' as const,
  Between: 'between' as const,
  Contains: 'contains' as const,
  ElemMatch: 'elem_match' as const,
  EndsWith: 'ends_with' as const,
  Equal: '=' as const,
  Exists: 'exists' as const,
  GreaterThan: '>' as const,
  GreaterThanOrEqual: '>=' as const,
  HasValue: 'has_value' as const,
  In: 'in' as const,
  Is: 'is' as const,
  IsNot: 'is_not' as const,
  IsNotNull: 'is_not_null' as const,
  IsNull: 'is_null' as const,
  LessThan: '<' as const,
  LessThanOrEqual: '<=' as const,
  MissingValue: 'missing_value' as const,
  Mod: 'mod' as const,
  Not: 'not' as const,
  NotEqual: '!=' as const,
  NotExists: 'not_exists' as const,
  NotIn: 'not_in' as const,
  Regex: 'regex' as const,
  Search: 'search' as const,
  StartsWith: 'starts_with' as const,
} as const;

export const FilterOperatorUtils = {
  values: Object.values(FilterOperator),
  keys: Object.keys(FilterOperator) as Array<keyof typeof FilterOperator>,
  entries: Object.entries(FilterOperator) as Array<[keyof typeof FilterOperator, FilterOperator]>,
  isValid: (value: any): value is FilterOperator => Object.values(FilterOperator).includes(value),
  fromKey: (key: keyof typeof FilterOperator): FilterOperator => FilterOperator[key],
};

